"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DictionarySchema = void 0;
const schema_1 = require("../schema");
const schema_type_1 = require("../schema-type");
class DictionarySchema extends schema_1.Schema {
    constructor(name, description, elementType, objectInitializer) {
        super(name, description, schema_type_1.SchemaType.Dictionary);
        this.elementType = elementType;
        this.apply(objectInitializer);
    }
}
exports.DictionarySchema = DictionarySchema;
//# sourceMappingURL=dictionary.js.map